import { Divider, Typography } from "@mui/material";
import styled from "styled-components";
import { Account, MASK_TYPE } from "types";
import AssetsDisplay from "components/clientInfoTemplate/AssetsDisplay";
import MaskedValue from "common/MaskedValue";

export default function AssetsSection(props: {
  assetsAccounts: Account[];
  assetsTotal: number;
}) {
  return (
    <SectionContainer>
      <SectionHeading>
        <Typography variant={"h6"}>Assets</Typography>
      </SectionHeading>
      {props.assetsAccounts.length === 0 && (
        <MessageContainer>No Asset Accounts</MessageContainer>
      )}
      {props.assetsAccounts.length > 0 && (
        <>
          <AssetsDisplay accounts={props.assetsAccounts} />
          <Divider style={{ margin: "0.15em 0em 0.5em 0em" }} />
          <TotalBalanceRow>
            <LeftContent>Total </LeftContent>{" "}
            <RightContent>
              {MaskedValue(MASK_TYPE.MONEY, props.assetsTotal.toString())}
            </RightContent>
          </TotalBalanceRow>
        </>
      )}
    </SectionContainer>
  );
}

const SectionContainer = styled.div`
  padding: 0.5em 0.5em 0em 0.5em;
`;
const SectionHeading = styled.div`
  padding-bottom: 0.5em;
`;
const MessageContainer = styled.div`
  padding-bottom: 1em;
`;
const LeftContent = styled.div`
  font-weight: 500;
  width: 300px;
  flex: 1;
`;
const TotalBalanceRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 2em;
`;

const RightContent = styled.div`
  text-align: right;
  font-weight: 500;
`;
